import React, { useState } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { Tags, GitBranch } from "lucide-react";

import { getBranches, getGitTags } from "../../Api/services/github";

import css from "./branch-selector.styl";

export const BranchSelect = (props) => {
	const [type, setType] = useState("branch");

	// Run both queries to get branches and tags
	const { data: branchesData, isLoading: branchesLoading } = useQuery({
		queryKey: ["github-branches"],
		queryFn: () => getBranches(),
		refetchInterval: 30_000,
	});

	const { data: tagsData, isLoading: tagsLoading } = useQuery({
		queryKey: ["github-tags"],
		queryFn: () => getGitTags(),
		refetchInterval: 30_000,
	});

	const data = type === "branch" ? branchesData : tagsData;
	const isLoading = type === "branch" ? branchesLoading : tagsLoading;

	const branches = (data ?? []).map((branch) => ({
		value: branch.name,
		label: branch.name,
		branchName: branch.name,
		commitHash: branch.commit.sha,
	}));

	return (
		<div className={css.wrapper}>
			<Select
				value={props.value}
				onChange={props.onChange}
				options={branches}
				isSearchable
				isClearable
				isLoading={isLoading}
			/>
			<div className={css.switches}>
				<div className={`${css.highlight} ${type === "branch" ? css.offset : ""}`} />

				<div className={`${css.option} ${type === "tag" ? css.active : ""}`} onClick={() => setType("tag")}>
					<Tags size={16} />
				</div>

				<div
					className={`${css.option} ${type === "branch" ? css.active : ""}`}
					onClick={() => setType("branch")}
				>
					<GitBranch size={16} />
				</div>
			</div>
		</div>
	);
};
